export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "9222edf.worker.js");
}
